<div  (click)="navigateTo()" class="slide-school-pro">
    <div class="content">
        <div class="pro-title">
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/UNHIDE_Pro.png" alt="UNHIDE PRO">
        </div>

        <div class="price">
            <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/background/text-acesso-ilimitado-left-v2.png" class="img-ilimitado" alt="Acesso Ilimitado" />
            <h3>todos os cursos<br> a partir de R$ 44/mês*</h3>
            <h4>*no plano anual</h4>
        </div>

    </div>
</div>
